import React from 'react';
import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';

function List() {

    const pathFrontEnd = '/gci/obras-projects/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/obras-projects/delete`,
        endpoint: `${endpointBackend}gci/obras-projects/getall`
    }

    let list = {
        labelTitle: 'Vínculo Obra x Projeto',
        labelTitleButtonAdd: 'Vincular Obra ao Projeto',
        fieldsShowOnDelete: ['nome_obra'],
        canAdd: false,
        canDelete: false,
        columns: [
            {
                name: 'has_project',
                label: 'Projeto Vinculado',
                width: '15%',
                cell: (row) => {
                    const statusColors = {
                        true: '#38a169',
                        false: '#ff1e1eff',
                    };
                    const color = statusColors[row.has_project] || '#a0aec0';
                    return (
                        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{
                                display: 'inline-block',
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                backgroundColor: color,
                                flexShrink: 0,
                            }} />
                            {row.has_project ? 'Sim' : 'Não'}
                        </span>
                    );
                }
            },
            {
                name: 'nome_obra',
                label: 'Obra',
                width: '40%'
            },
            {
                name: 'nome_projeto',
                label: 'Nome do Projeto',
                width: '30%'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                canAdd={list.canAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}

export default List;
